import { createSelector } from 'reselect';
import { arrsToSelectableObject } from '../../core/utils/methods';
import { AppState } from '../reducers';
import { PermittingState } from '../reducers/permitting.reducer';

const permittingState = (state: AppState): PermittingState => state.permitting;

export namespace PermittingSelectors {
  export const getJurisdictionList = createSelector(
    [permittingState],
    (state: PermittingState) => state.jurisdictionList,
  );

  export const getJurisdictionListLikeSelectorOptions = createSelector(
    [permittingState],
    (state: PermittingState) =>
      arrsToSelectableObject(state.jurisdictionList, 'id', 'jurisdictionName'),
  );

  export const getPermittingBrowseData = createSelector(
    [permittingState],
    (state: PermittingState) => state.browseData,
  );

  export const getPermittingUsersOptions = createSelector(
    [permittingState],
    (state: PermittingState) => state.permittingUsersOptions,
  );

  export const getTabLoadingState = (tabName: string) =>
    createSelector(
      [permittingState],
      state => state.loadingTabs[tabName] || false,
    );

  export const getSummaryTabData = createSelector(
    [permittingState],
    state => state.tabData.summary,
  );

  export const getSiteData = createSelector(
    [permittingState],
    state => state.tabData.summary.site,
  );

  export const getWorkflowTabData = createSelector(
    [permittingState],
    state => state.tabData.workflow,
  );

  export const getContactsTabData = createSelector(
    [permittingState],
    state => state.tabData.contacts,
  );

  export const getJurisdictionAuditTabData = createSelector(
    [permittingState],
    state => state.tabData.jurisdictionAudit,
  );

  export const getSofTabData = createSelector(
    [permittingState],
    state => state.tabData.sof,
  );

  export const getSummaryProjectType = createSelector(
    [permittingState],
    state => state.tabData.summary.project?.projectType.value,
  );

  export const isTabDataLoaded = (tabName: keyof PermittingState['tabData']) =>
    createSelector([permittingState], state => state.tabData[tabName].loaded);

  export const getPermittingDetailsHeaderData = createSelector(
    [permittingState],
    (state: PermittingState) => state.detailsData.site,
  );

  export const getInactivePermittingUsers = createSelector(
    [permittingState],
    (state: PermittingState) => state.tabData.workflow.inactivePermittingUsers,
  );

  export const getProjectType = createSelector(
    [permittingState],
    (state: PermittingState) => state.tabData.summary.project.projectType.value,
  );

  export const getProjectId = createSelector(
    [permittingState],
    (state: PermittingState) => state.tabData.summary.project.id,
  );

  export const getPermitTypeTableData = (permittingId?: string) =>
    createSelector(
      [permittingState],
      ({
        originalPermitTypeTableData,
        currentPermitTypeTableData,
      }: PermittingState) => ({
        originalPermitTypeTableData: permittingId
          ? originalPermitTypeTableData[permittingId]
          : [],
        currentPermitTypeTableData: permittingId
          ? currentPermitTypeTableData[permittingId]
          : [],
      }),
    );

  export const getAllPermitTypeTablesData = createSelector(
    [permittingState],
    ({
      originalPermitTypeTableData,
      currentPermitTypeTableData,
    }: PermittingState) => ({
      originalPermitTypeTableData,
      currentPermitTypeTableData,
    }),
  );
}
